import request from '@/utils/request'



// 首页
// 我的消息
export function APIcywtALL(data) {
    return request({
        method: 'post',
        url: "/yzdservice/comPro/getList",
        data: data
    })
}
